import { POSITIVE, REDACT_NEGATIVE, REDACT_POSITIVE } from 'conversations-message-history/customer-agent-feedback-message/constants/messageTypes';
import { getExistingFeedback } from 'conversations-visitor-message-history/message-feedback/operators/getExistingFeedback';
// @ts-expect-error Untyped Dependency
import { getCurrentThreadHistoryData } from '../../thread-history/selectors/getCurrentThreadHistoryData';
import { getUnpublishedMessagesForCurrentThread } from '../selectors/getUnpublishedMessagesForCurrentThread';
import { publishFeedbackMessage } from './publishFeedbackMessage';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES, FEEDBACK_ACTIONS } from '../../usage-tracking/constants/eventNames';
const redactOf = sentiment => sentiment === POSITIVE ? REDACT_POSITIVE : REDACT_NEGATIVE;
export const dispatchFeedbackChain = ({
  messageId,
  feedbackType
}) => (dispatch, getState) => {
  const state = getState();
  const {
    sentiment,
    latestFeedbackMessageId
  } = getExistingFeedback(messageId, getUnpublishedMessagesForCurrentThread(state), getCurrentThreadHistoryData(state));
  const redactingFeedbackMessageId = latestFeedbackMessageId !== null && latestFeedbackMessageId !== void 0 ? latestFeedbackMessageId : undefined;
  if (sentiment === null) {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: feedbackType === POSITIVE ? FEEDBACK_ACTIONS.PROMPT_UPVOTED : FEEDBACK_ACTIONS.PROMPT_DOWNVOTED
    }));
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType,
      redactingFeedbackMessageId
    }));
  }
  if (sentiment === feedbackType) {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: feedbackType === POSITIVE ? FEEDBACK_ACTIONS.PROMPT_UPVOTE_REMOVED : FEEDBACK_ACTIONS.PROMPT_DOWNVOTE_REMOVED
    }));
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType: redactOf(sentiment),
      redactingFeedbackMessageId
    }));
  }
  dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
    action: sentiment === POSITIVE ? FEEDBACK_ACTIONS.PROMPT_UPVOTE_REMOVED : FEEDBACK_ACTIONS.PROMPT_DOWNVOTE_REMOVED
  }));
  return dispatch(publishFeedbackMessage({
    messageId,
    feedbackType: redactOf(sentiment),
    redactingFeedbackMessageId
  })).then(redactId => {
    if (!redactId) {
      return null;
    }
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: feedbackType === POSITIVE ? FEEDBACK_ACTIONS.PROMPT_UPVOTED : FEEDBACK_ACTIONS.PROMPT_DOWNVOTED
    }));
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType,
      redactingFeedbackMessageId: redactId
    }));
  });
};